export default {
  'objectStorage.list.title': 'Object Storage',
  'objectStorage.list.columns.title1': 'Name',
  'objectStorage.list.columns.title2': 'Platform',
  'objectStorage.list.columns.title3': 'Region',
  'objectStorage.list.columns.title4': 'Options',
  'objectStorage.list.top.title1': 'Third-party object storage',
  'objectStorage.list.top.text1': 'Authorized access, immediate use',
  'objectStorage.list.top.title2': 'LightCDN object storage',
  'objectStorage.list.top.text2': 'Build freely, maintain full control',
  'objectStorage.list.top.btnText1': 'Authorize Access',
  'objectStorage.list.top.btnText2': 'Remind me',
  'objectStorage.list.top.btnText3': 'Reminded',
  'objectStorage.list.Popconfirm.okText': 'Yes',
  'objectStorage.list.Popconfirm.cancelText': 'Cancel',
  'objectStorage.list.Popconfirm.cdnText': 'Go to CDN Resources',
  'objectStorage.list.Popconfirm.delText.1': 'Confirm deletion of ',
  'objectStorage.list.Popconfirm.delText.2': ' object storage?',
  'objectStorage.list.Popconfirm.delNoText.1': 'There are still ',
  'objectStorage.list.Popconfirm.delNoText.2': ' resources using ',
  'objectStorage.list.Popconfirm.delNoText.3':
    ' as origin. Please change the origin before deletion.',
  'objectStorage.create.btnText': 'Authorize Object Storage',
  'objectStorage.create.form.name': 'Name',
  'objectStorage.create.form.name.label':
    '(A name to distinguish the space on this platform, not the third-party object storage name)',
  'objectStorage.create.form.name.message': 'Please enter a valid name',
  'objectStorage.create.form.name.rule': 'Please use 4-20 characters',
  'objectStorage.create.form.name.placeholder': 'Please select an authorized object storage',
  'objectStorage.create.form.PleaseInput': 'Please input',
  'objectStorage.create.form.PleaseSelect': 'Please select',
  'objectStorage.create.form.thirdPartyName': 'Third-party platform',
  'objectStorage.create.form.secretKeyAK': 'Access key ID (AK)',
  'objectStorage.create.form.secretKeyAK.message': 'Please enter a valid access key ID (AK)',
  'objectStorage.create.form.secretKeySK': 'Secret access key (SK)',
  'objectStorage.create.form.secretKeySK.message': 'Please enter a valid secret access key (SK)',
  'objectStorage.create.form.secretKeySK.placeholder': 'Requires revalidation',
  'objectStorage.create.form.regionCode': 'Region',
  'objectStorage.create.form.regionCode.placeholder': 'E.g.: us-east-2',
  'objectStorage.create.form.regionCode.message': 'Please enter a valid region',
  'objectStorage.create.form.Endpoint': 'Endpoint (Optional)',
  'objectStorage.create.form.Endpoint.placeholder':
    'Endpoint domain or URL (only required for non-AWS applications)',
  'objectStorage.create.form.EndpointStyle': 'Bucket Access Style in Endpoint',
  'objectStorage.create.form.access': 'Access method',
  'objectStorage.create.form.StorageSpaceName': 'Storage space name',
  'objectStorage.create.form.StorageSpaceName.placeholder': 'E.g.: oss-cn-shanghai.aliyuncs.com',
  'objectStorage.create.form.StorageSpaceName.message': 'Please enter a valid storage space name',
  'objectStorage.create.form.access.tip1': 'Access URL: CDN hostname/path/filename',
  'objectStorage.create.form.access.tip2':
    'Access URL: CDN hostname/BUCKET-NAME/path/filename. If your files are stored directly in object storage, the path may not exist.',
  'objectStorage.create.form.document': 'Click here to learn how to connect →',
  'objectStorage.create.form.bucketAddressStyle.1': 'Path',
  'objectStorage.create.form.bucketAddressStyle.2': 'Subdomain',
  'objectStorage.create.form.bucketParam.1': 'Specify storage space',
  'objectStorage.create.form.bucketParam.2': 'URL prefix/BUCKET-NAME/filename',
  'objectStorage.create.form.name.unique': 'The name already exsists.',
};
